import { Component, OnInit } from '@angular/core';
import { TermsConditionsService } from './terms-conditions.service';
import { ToastService } from '../common/toast.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {
  loading: boolean = false;
  termsData: any = null;
  errorMessage: string = '';

  constructor(
    private termsService: TermsConditionsService,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.loadTermsData();
  }

  loadTermsData() {
    this.loading = true;
    this.errorMessage = '';
    
    this.termsService.getTermsConditionsData().subscribe(
      (response) => {
        this.loading = false;
        if (response && response.status === 'success') {
          this.termsData = response.data;
        } else {
          this.errorMessage = (response && response.message) || 'Failed to load terms and conditions';
          this.toast.error(this.errorMessage);
        }
      },
      (error) => {
        this.loading = false;
        this.errorMessage = 'An error occurred while loading terms and conditions';
        this.toast.error(this.errorMessage);
        console.error('Error loading terms and conditions:', error);
      }
    );
  }
}




// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/terms-conditions/terms-conditions.component.ts